import { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const normalizeIconSrc = (src) => {
  const trimmed = (src || '').trim();
  if (!trimmed) return '';
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

const CategoryListIcon = ({ src, alt, size = 35, boxSize = 40, className = '', isDarkMode = false }) => {
  const [hasError, setHasError] = useState(false);
  const iconSrc = normalizeIconSrc(src);

  useEffect(() => {
    setHasError(false);
  }, [iconSrc]);

  const showPlaceholder = !iconSrc || hasError;

  return (
    <div
      className={`rounded d-flex align-items-center justify-content-center ${className}`.trim()}
      style={{
        width: boxSize,
        height: boxSize,
        minWidth: boxSize,
        backgroundColor: isDarkMode ? '#4a5568' : '#d9d9d9',
      }}
    >
      {showPlaceholder ? (
        <i
          className="fa fa-image"
          style={{ fontSize: Math.round(size * 0.5), color: isDarkMode ? '#a0aec0' : '#6c757d' }}
          aria-hidden="true"
        />
      ) : (
        <LazyLoadImage
          src={iconSrc}
          alt={alt || 'Category icon'}
          style={{
            height: size,
            width: size,
            objectFit: 'contain',
          }}
          onError={() => setHasError(true)}
        />
      )}
    </div>
  );
};

export default CategoryListIcon;
